import React from 'react';

const LastContainer = ({ data, onClick }) => {
  return (
    <div
      onClick={onClick}
      className='flex w-full border border-black text-xxs sm:text-xs md:text-sm lg:text-lg xl:text-xl'
    >
      <div className='flex flex-col w-[12%] border border-black'>
        <div className='bg-blue-200 h-[40px] sm:h-[60px] md:h-[80px] flex justify-center items-center text-center border-b-2 border-black'>
          입/출고
        </div>
        <div className='bg-blue-200 h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b-2 border-black'>
          영업(톤)
        </div>
        <div className='bg-blue-200 h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center'>
          원료(톤)
        </div>
      </div>
      <div className='flex flex-col w-[36%] border border-black'>
        <div className='bg-blue-200 h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b-2 border-black'>
          판매 & 입고 (일)
        </div>
        <div className='flex'>
          <div className='flex flex-col w-[33.3%]'>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-b-2 border-black'>
              목표
            </div>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center'></div>
          </div>
          <div className='flex flex-col w-[33.3%] border-l-2 border-black'>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-b-2 border-black'>
              실적
            </div>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center'></div>
          </div>
          <div className='flex flex-col w-[33.4%] border-l-2 border-black'>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-b-2 border-black'>
              달성율
            </div>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center'></div>
          </div>
        </div>
      </div>
      <div className='flex flex-col w-[36%] border border-black'>
        <div className='bg-blue-200 h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b-2 border-black'>
          판매 & 입고 (누계)
        </div>
        <div className='flex'>
          <div className='flex flex-col w-[33.3%]'>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-b-2 border-black'>
              목표
            </div>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center'></div>
          </div>
          <div className='flex flex-col w-[33.3%] border-l-2 border-black'>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-b-2 border-black'>
              실적
            </div>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center'></div>
          </div>
          <div className='flex flex-col w-[33.4%] border-l-2 border-black'>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-b-2 border-black'>
              달성율
            </div>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center'></div>
          </div>
        </div>
      </div>
      <div className='flex flex-col w-[24%] border border-black'>
        <div className='h-[40px] sm:h-[60px] md:h-[80px] bg-blue-200 flex justify-center items-center text-center border-b-2 border-black'>
          재고(톤)비고
        </div>
        <div className='flex'>
          <div className='flex flex-col w-[50%]'>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center'></div>
          </div>
          <div className='flex flex-col w-[50%] border-l-2 border-black'>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
            <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center'></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LastContainer;
